<div app-theme>
    <app-infobar></app-infobar>
    <main class="container-fluid" id="wrapper">
        <router-outlet></router-outlet>
    </main>

    <app-socialbar [show]="showSocialbar"></app-socialbar>
    <cookie-consent-popup *ngIf="showConsent === false"></cookie-consent-popup>
</div>
